import { values } from './enums'

const _enum = {
  Error: 0,
  Warning: 1,
  Information: 2,
  InvalidExpression: 3,
  Succeeded: 4,
  NotChecked: 5,
  NoCheckingRules: 6
}

export const CheckingRuleResult = {
  enumName: 'CheckingRuleResult',
  enum: _enum,
  values: values(_enum)
}



// WEBPACK FOOTER //
// ./src/enums/checkingRuleResult.js